import { useField, connect } from 'formik';
import styled from 'styled-components';

import FieldContextFeeder from '../components/FieldContextFeeder';
import Error from '../components/Error';

import { Select } from '~ui-kit';

// SelectIdField represent the inner value as an id instead of the
// object required by react-select

// Why?

// Because this way we can have symmetric representation of the data in both
// the frontend and the backend which should make actions like editing
// an order easier

const idToOption = (id, options) => {
  // undefined creates undesired behavior in react-select, so we prefer null
  return options?.find(option => option.value === id) || null;
};

const optionToId = option => {
  return option?.value;
};

// TODO: find out why errors aren't showing
const SelectIdField = props => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;

  const name = props.id || props.name;

  const localProps = {
    ...field,
    ...props,
    error,
    value: idToOption(field.value, props.options),
    // https://github.com/formium/formik/issues/789
    onChange: option => {
      const id = optionToId(option);
      setFieldValue(name, id);
      if (props.onChange) props.onChange(id);
    },
  };

  return (
    <Container className={props.className}>
      <Select {...localProps} />
      {error ? <Error>{meta.error}</Error> : null}
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

export default FieldContextFeeder(connect(SelectIdField));
